import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=5a1e386b&"
import script from "./Scroll.vue?vue&type=script&lang=js&"
export * from "./Scroll.vue?vue&type=script&lang=js&"
import style0 from "./Scroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports